<template>
  <div>
    <b-row v-if="searchable">
      <b-col cols="12" md="6">
        <v-text-field
          dense
          outlined
          v-model="inputValue"
          append-icon="mdi-file-find"
          placeholder="جست و جو کنید"
          @keydown="searchItem($event)"
          hide-details="auto"
          clearable
          @click:clear="clearInput"
          class="mb-2 mr-1 evaluation-1"
          :disabled="disabledSearch"
        ></v-text-field>
      </b-col>
    </b-row>
    <v-data-table
      id="__table"
      :loading="loading"
      :headers="headers"
      :items="items"
      :item-key="itemKey"
      :class="tableClasses"
      :style="tableStyles"
      v-bind="$attrs"
      disable-pagination
      v-model="selected"
      :checkbox-color="checkboxColor"
      :single-select="singleSelect"
      @input="itemSelected"
      :items-per-page="itemsPerPage"
      :expanded.sync="expanded"
      :height="height"
    >
      <template v-for="(_, slotName) of $scopedSlots" v-slot:[slotName]="scope">
        <slot :name="slotName" v-bind="scope" />
      </template>

      <template v-slot:no-data>
        <p>جدول خالی است</p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: [],
    },
    items: {
      type: Array,
      default: [],
    },
    pagination: {
      type: Boolean,
      default: false,
    },
    pageCount: {
      type: [Number, String],
      default: 0,
    },
    type: {
      type: String,
      default: '',
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    deleteable: {
      type: Boolean,
      default: true,
    },
    showDetailItem: {
      type: Boolean,
      default: false,
    },
    itemKey: {
      type: String,
      default: 'id',
    },
    checkboxColor: {
      type: String,
      default: 'primary',
    },
    tableClasses: {
      type: String,
      description: 'Table Classes',
    },
    tableStyles: {
      type: String,
      description: 'Table Styles',
    },
    itemPerPage: {
      type: [String, Number],
      default: 10,
    },

    singleSelect: {
      type: [String, Boolean],
      default: true,
    },

    selections: {
      type: Array,
      default: () => [],
    },
    searchable: {
      type: [String, Boolean],
      default: false,
    },
    disabledSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageNumber: 1,
      expanded: [],
      height: '400',
      searching: false,
      inputValue: null,
    };
  },
  created() {
    this.inputValue = null;
    window.addEventListener('resize', this.tableHeight);
  },
  mounted() {
    this.tableHeight();
  },

  destroyed() {
    window.removeEventListener('resize', this.tableHeight);
  },
  computed: {
    itemsPerPage: {
      get: function () {
        return this.itemPerPage;
      },
      set: function (newValue) {},
    },
    selected: {
      get() {
        return this.selections;
      },
      set(value) {},
    },
  },
  watch: {
    items(after) {
      if (after && after.length) {
        this.tableHeight();
      }
    },
    itemPerPage(after) {
      this.itemsPerPage = after;
    },
    itemsPerPage() {
      this.$emit('itemsPerPageChanged', this.itemsPerPage);
    },
    pageNumber() {
      this.$emit('pageNumberChanged', this.pageNumber);
    },
  },
  methods: {
    searchItem() {
      if (this.searching) {
        clearTimeout(this.searching);
      }
      this.searching = setTimeout(() => {
        this.searching = true;
        this.$emit('searchItem', this.inputValue);
      }, 600);
    },
    clearInput() {
      this.inputValue = null;
      this.$emit('searchItem', this.inputValue);
    },
    tableHeight() {
      if (!this.pagination && !this.height) {
        if (
          document.documentElement.clientWidth > 576 &&
          document.documentElement.clientWidth < 1400
        ) {
          if (this.items.length > 10) {
            this.height = 400;
          }
        } else {
          if (this.items.length > 15) {
            let position = document.querySelector('#__table').offsetTop;
            this.height = window.innerHeight - (position + 160);
          }
        }
      } else {
        this.height = null;
      }
    },
    itemSelected(rows) {
      this.$emit('items-selected', rows);
    },
    editItem(item) {
      this.$emit('editItem', item);
    },
    deleteItem(item) {
      this.$emit('deleteItem', item);
    },
    enableItem(item) {
      this.$emit('enableItem', item);
    },
    disableItem(item) {
      this.$emit('disableItem', item);
    },
    showDetail(item) {
      this.$emit('showDetail', item);
    },
  },
};
</script>

<style lang="scss">
.v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  box-shadow: none !important;
}
</style>
